import API from './api';

export default {
    // Create a new staff invite
    createStaffInvite: (organizationId, inviteData) => API({
        url: `organizations/${organizationId}/staff-invites`,
        method: 'POST',
        json: inviteData,
    }),

    // Get all pending staff invites for an organization
    getStaffInvites: (organizationId) => API({
        url: `organizations/${organizationId}/staff-invites`,
        method: 'GET',
    }),

    // Cancel a staff invite
    cancelStaffInvite: (organizationId, inviteId) => API({
        url: `organizations/${organizationId}/staff-invites/${inviteId}`,
        method: 'DELETE',
    }),

    // Get staff invite details by invite code (public endpoint)
    getStaffInviteByCode: (inviteCode) => API({
        url: `staff-invites/${inviteCode}`,
        method: 'GET',
    }),

    // Accept a staff invitation
    acceptStaffInvite: (inviteCode) => API({
        url: `staff-invites/${inviteCode}/accept`,
        method: 'POST',
        json: {},
    }),
};